module.exports = __webpack_public_path__ + "img/free-4.a91824f9.png";